var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _rect5, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustpilotRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 22,
    viewBox: "0 0 116 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.2987,
    height: 21.2987,
    transform: "translate(0.492188)",
    fill: "#01B67B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.142 14.5647L14.3812 13.6973L15.7346 18.1044L11.142 14.5647ZM18.5966 8.86827H12.8947L11.142 3.19531L9.38934 8.86827H3.6875L8.30222 12.3846L6.54951 18.0575L11.1642 14.5412L14.0041 12.3846L18.5966 8.86827Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21.2987,
    height: 21.2987,
    transform: "translate(23.9219)",
    fill: "#01B67B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5717 14.5647L37.8109 13.6973L39.1643 18.1044L34.5717 14.5647ZM42.0263 8.86827H36.3244L34.5717 3.19531L32.819 8.86827H27.1172L31.7319 12.3846L29.9792 18.0575L34.5939 14.5412L37.4337 12.3846L42.0263 8.86827Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 21.2987,
    height: 21.2987,
    transform: "translate(47.3477)",
    fill: "#01B67B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9975 14.5647L61.2367 13.6973L62.59 18.1044L57.9975 14.5647ZM65.4521 8.86827H59.7502L57.9975 3.19531L56.2448 8.86827H50.543L55.1577 12.3846L53.405 18.0575L58.0197 14.5412L60.8595 12.3846L65.4521 8.86827Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 21.2987,
    height: 21.2987,
    transform: "translate(70.7773)",
    fill: "#01B67B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4272 14.5647L84.6664 13.6973L86.0197 18.1044L81.4272 14.5647ZM88.8817 8.86827H83.1799L81.4272 3.19531L79.6745 8.86827H73.9727L78.5874 12.3846L76.8347 18.0575L81.4494 14.5412L84.2892 12.3846L88.8817 8.86827Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 21.2987,
    height: 21.2987,
    transform: "translate(94.207)",
    fill: "#01B67B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.857 14.5647L108.096 13.6973L109.449 18.1044L104.857 14.5647ZM112.311 8.86827H106.61L104.857 3.19531L103.104 8.86827H97.4023L102.017 12.3846L100.264 18.0575L104.879 14.5412L107.719 12.3846L112.311 8.86827Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustpilotRating);
export default __webpack_public_path__ + "9aa6f470f6dbb500c2a59da232565f36.svg";
export { ForwardRef as ReactComponent };